export const FAQ_3_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    question: "What is the duration of the course?",
    answer: "The course duration is typically 1 year.",
    priority: 1,
  },

  FAQ_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Main heading",
      value: "FAQs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. FAQs",
      required: false,
      defaultValue: "FAQs",
    },
    {
      fieldName: "title_text_color",
      label: "Heading text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "title_1",
      label: "Subtitle (below heading)",
      value: "Find answers to commonly asked questions.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "One line of supporting copy",
      required: false,
      defaultValue: "Find answers to commonly asked questions.",
    },
    {
      fieldName: "title_1_color",
      label: "Subtitle text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "section_background_color",
      label: "Section background (outer) — used when no background image",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "section_background_image",
      label: "Section background image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Wide image behind the FAQ block",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_background_image_alt",
      label: "Background image alt text (accessibility)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image if meaningful; leave empty if decorative",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Brand purple (left rail + open accordion bar)",
      value: "#130554",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Sidebar and expanded item header",
      required: false,
      defaultValue: "#130554",
    },
    {
      fieldName: "accordion_muted_index_color",
      label: "Collapsed index number color (01, 02, …)",
      value: "#C5C5C5",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#C5C5C5",
    },
    {
      fieldName: "accordion_item_border_color",
      label: "Collapsed item border",
      value: "#E0E0E0",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#E0E0E0",
    },
    {
      fieldName: "accordion_answer_surface_bg",
      label: "Answer panel background (when open)",
      value: "#F8F8F8",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F8F8F8",
    },
    {
      fieldName: "accordion_answer_surface_border",
      label: "Answer panel border (when open)",
      value: "#C5C5C5",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#C5C5C5",
    },
    {
      fieldName: "status",
      label: "FAQ status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. About, Apply, Study",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Inactive — label & chevron (on purple rail)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Inactive — row fill (use transparent to show rail)",
      value: "transparent",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "transparent",
    },
    {
      fieldName: "active_text_color",
      label: "Active — text & chevron (pill)",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "active_background_color",
      label: "Active — pill background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "order_index",
      label: "Display order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Category status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  FAQ_TABLE_FIELDS_CONFIG: [
    {
      header: "Question",
      fieldName: "question",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter question",
      required: true,
    },
    {
      header: "Question text color (collapsed bar)",
      fieldName: "question_text_color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Answer",
      fieldName: "answer",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter answer",
      required: true,
    },
    {
      header: "Answer text color",
      fieldName: "answer_text_color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
    },
  ],
};
